/*
  Normalises legal text pasted into the Shopify editor so every page reads the same:
  - "<p><strong>Heading</strong></p>" and "<p><strong>Heading</strong><br>text</p>" -> <h2> (+ <p>)
  - single-item <ol> used as a numbered heading -> <h2>"N. Heading"</h2>
  - "• item" lines inside a paragraph -> <ul>
  - "Last updated" paragraph -> .legal-updated
*/
(function () {
  var BR = /<br\s*\/?>/gi;

  function isBlank(node) {
    return node.nodeType === 3 ? !node.textContent.trim() : node.nodeName === 'BR';
  }

  function meaningful(el) {
    return Array.prototype.filter.call(el.childNodes, function (n) {
      return !isBlank(n);
    });
  }

  function heading(html) {
    var h = document.createElement('h2');
    h.innerHTML = html.trim().replace(/:$/, '');
    return h;
  }

  function isBold(node) {
    return node && node.nodeType === 1 && (node.nodeName === 'STRONG' || node.nodeName === 'B');
  }

  function fixParagraph(p) {
    // Bullet lines typed as "• text<br>"
    if (/(^|<br\s*\/?>)\s*[•·▪]\s*/i.test(p.innerHTML)) {
      var frag = document.createDocumentFragment();
      var list = null;
      var text = [];
      var flushText = function () {
        if (!text.length) return;
        var np = document.createElement('p');
        np.innerHTML = text.join('<br>');
        frag.appendChild(np);
        text = [];
      };
      p.innerHTML.split(BR).forEach(function (line) {
        var m = line.match(/^\s*[•·▪]\s*([\s\S]*)$/);
        if (m) {
          flushText();
          if (!list) list = frag.appendChild(document.createElement('ul'));
          list.appendChild(document.createElement('li')).innerHTML = m[1].trim();
        } else if (line.trim()) {
          list = null;
          text.push(line.trim());
        }
      });
      flushText();
      p.replaceWith(frag);
      return;
    }

    var kids = meaningful(p);
    var first = kids[0];
    if (!isBold(first) || first.textContent.trim().length > 90) return;

    if (kids.length === 1) {
      p.replaceWith(heading(first.innerHTML));
      return;
    }

    // <strong>Heading</strong><br>Body text
    var next = first.nextSibling;
    while (next && next.nodeType === 3 && !next.textContent.trim()) next = next.nextSibling;
    if (next && next.nodeName === 'BR') {
      p.parentNode.insertBefore(heading(first.innerHTML), p);
      first.remove();
      next.remove();
    }
  }

  function normalise(root) {
    if (root.dataset.legalDone) return;
    root.dataset.legalDone = '1';

    // Unwrap a lone plain <div> wrapper
    var only = meaningful(root);
    if (only.length === 1 && only[0].nodeName === 'DIV' && !only[0].className) {
      only[0].replaceWith.apply(only[0], Array.prototype.slice.call(only[0].childNodes));
    }

    root.querySelectorAll('[dir]').forEach(function (el) {
      el.removeAttribute('dir');
    });

    // Single-item <ol> used as "1. Heading"
    root.querySelectorAll(':scope > ol').forEach(function (ol) {
      var items = ol.querySelectorAll(':scope > li');
      if (items.length !== 1 || items[0].children.length || items[0].textContent.trim().length > 90) return;
      var n = parseInt(ol.getAttribute('start') || '1', 10);
      ol.replaceWith(heading(n + '. ' + items[0].innerHTML));
    });

    root.querySelectorAll(':scope > p').forEach(fixParagraph);

    root.querySelectorAll(':scope > p').forEach(function (p) {
      // Trailing <br> and empty paragraphs
      while (p.lastChild && isBlank(p.lastChild)) p.lastChild.remove();
      if (!p.textContent.trim() && !p.querySelector('img')) p.remove();
    });

    var firstP = root.querySelector(':scope > p');
    if (firstP && /^\s*last updated/i.test(firstP.textContent)) {
      firstP.classList.add('legal-updated');
      firstP.textContent = firstP.textContent.replace(/[\[\]]/g, '').trim();
    }
  }

  function run() {
    document.querySelectorAll('.legal-rte, .shopify-policy__body .rte').forEach(normalise);
  }

  // Run straight away for content already parsed (script sits after it), and again once the DOM is ready.
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
})();
